module.exports = __webpack_public_path__ + "assets/img/mr10.1a962d7f.png";